// import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource/google-sans/400.css';
import '@fontsource/google-sans/500.css';
import '@fontsource/google-sans/600.css';
import '@fontsource/google-sans/700.css';
import './styles/fonts.css';
import './styles/app-theme.css';
import './styles/qloop-inbox.css';
import './index.css';
import './styles/index.css';
import './components/InboxList.css';

// console.log('main.tsx is executing!');

const rootElement = document.getElementById('root');
// console.log('Root element:', rootElement);

if (!rootElement) {
  // console.error('Root element not found!');
} else {
  // console.log('Creating React root...');
  const root = ReactDOM.createRoot(rootElement);
  
  // console.log('Rendering App component...');
  root.render(
    <App />
); 
  // console.log('App component rendered!');
}
